<template>
  <IconLabel
    clickable
    background="primary"
    class="survey-banner"
    icon="icon-f-clock"
    :label="$t('ETAB.PAGES.DEMAND_DASHBOARD.@SURVEY_TODO')"
    @click="goToSurveyPage"
  />
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    methods: {
      goToSurveyPage() {
        this.$router.push({ name: ETAB_ROUTES.survey.name }).catch((suppressedError) => {});
      },
    },
  };
</script>

<style lang="scss">
  .survey-banner {
    margin: 15px 15px 0;
  }
</style>
